<template>
  <div class="form-group">
    <div class="item-name">
      <label class="item">フリガナ</label><label class="required">必須</label>
      <!-- <div v-if="$v.kana.$dirty">
        <div class="error-text margin-10" v-if="!$v.kana.required">
          ふりがなを入力してください。
        </div>
      </div> -->
    </div>
    <input
      class="form-control margin-right-10"
      type="text"
      placeholder="姓"
      @change="changeFamilyNameKana"
    />
     <input
      class="form-control"
      type="text"
      placeholder="名"
      @change="changeFirstNameKana"
    />
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  data () {
    return {
      familyNameKana: "",
      firstNameKana: ""
    }
  },
  // validations: {
  //   kana: {
  //     required
  //   },
  // },
  methods: {
    // status(validation) {
    //   return {
    //     error: validation.$error,
    //     dirty: validation.$dirty
    //   };
    // },
    changeFamilyNameKana(e) {
      this.familyNameKana = e.target.value
      this.$emit('handle-change-fimailynamekana', this.familyNameKana)
    },
    changeFirstNameKana(e) {
      this.firstNameKana = e.target.value
      this.$emit('handle-change-firstnamekana', this.firstNameKana)
    }
  }
}
</script>

<style>
.margin-right-10 {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/molecules/InputKana.vue